export default class EventCategoryModel {
  public name = "";
  public colour = "";
  public calendarId = "";
  public eventCategoryId = "";

  constructor(data?: any) {
    if (!data) {
      return;
    }

    Object.assign(this, data);
  }
}
